<template>
    <div class="messages">
        <slot v-for="message in messages">
            <div class="error" v-if="message.error">Error:{{message.text}}</div>
            <div class="info" v-else>Info:{{message.text}}</div>
        </slot>
    </div>
</template>

<script>

    export default {
        props: ["bus"],
        mounted: function() {
            this.bus.on("messageUpdate", this.updateMessage);
            this.bus.on("clearMessages", this.clearMessages);
        },
        beforeUnmount: function() {
            this.bus.off("messageUpdate", this.updateMessage);
            this.bus.off("clearMessages", this.clearMessages);
        },
        data: function() {
            return { messages: [] }; //{ error: false, text: "" }
        },
        methods: {
            updateMessage: function(msg) {
                this.messages.push(msg);
            },
            clearMessages: function() {
                this.messages = [];
            }
        }
    }
</script>